// lib/loading/loading.tsx
import styled from "@emotion/styled";
import { CircularProgress } from "@mui/material";
import { Suspense } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
`;
var LoadingMessage = () => /* @__PURE__ */ jsxs(LoadingContainer, { children: [
  /* @__PURE__ */ jsx(CircularProgress, { size: 18 }),
  " Loading... Please wait..."
] });
var Loading = ({ children }) => /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(LoadingMessage, {}), children });
export {
  Loading
};
